/* Publish by EComposer at 2026-10-15 10:31:32*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9nkgoui7iwu"]=  window.__ectimmers["ecom-9nkgoui7iwu"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-9nkgoui7iwu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9nkgoui7iwu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzhjslkxgb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzhjslkxgb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mct0khspvqp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mct0khspvqp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rfz99gxtyit').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rfz99gxtyit', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c8i8f3y5u9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c8i8f3y5u9j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i0rdi5vock9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i0rdi5vock9', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0xhvndz85fgn"]=  window.__ectimmers["ecom-0xhvndz85fgn"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-0xhvndz85fgn"]["covw9vh6z"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-0xhvndz85fgn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0xhvndz85fgn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gggm7q5loj4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gggm7q5loj4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-27eusmui6iuj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-27eusmui6iuj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xswjxiewguo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xswjxiewguo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kzztoh1jcn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kzztoh1jcn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}